import { loaderAction, setCashFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { CASH_FORM_INITIAL } from "../initialStateConstant";
import { getCashThunk } from "./getCashThunk";

export const updateCashThunk = (args) => async (dispatch, getState) => {
    const { user, cash } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.id);
        formData.append('type', args.type);
        formData.append('sum', args.sum);
        formData.append('payment_method', args.payment_method);
        formData.append('description', args.description);
        formData.append('date', args.date);

        const response = await api({ data: formData, link: 'update_cash' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            dispatch(setCashFormAction(CASH_FORM_INITIAL));
            // Запрашиваем кассу
            dispatch(getCashThunk({
                payment_method: cash.payment_method.id,
                date_from: cash.date_from,
                date_to: cash.date_to
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }

};